/** Only known legacy product hosts/paths; never redirect an unrelated path. */
export const PRODUCT_ORIGIN = "https://fisioemortopedia.com.br";
const CERT_PATHS: Record<string, string> = Object.fromEntries(
  ["lombar", "cervical", "eletro", "ombro", "tornozelo", "joelho", "quadril"].map((s) => [`/${s}`, `/certificacao-${s}`]),
);

export function productRedirect(rawUrl: string, hostHeader?: string | null): string | null {
  const url = new URL(rawUrl);
  const host = (hostHeader || url.hostname).toLowerCase().split(":")[0];
  const path = url.pathname.replace(/\/+$/, "") || "/";
  let destination: string | undefined;
  if (host === "star.fisioemortopedia.com.br" || host === "www.star.fisioemortopedia.com.br") {
    if (path === "/" || path === "/star") destination = "/star";
  } else if (host === "certificacao.fisioemortopedia.com.br" || host === "www.certificacao.fisioemortopedia.com.br") {
    destination = path === "/" ? "/certificacao" : CERT_PATHS[path];
    if (/^\/certificacao-(lombar|cervical|eletro|ombro|tornozelo|joelho|quadril)$/.test(path)) destination = path;
  } else {
    // Platform canonicalization preserves paths but may remove the old host.
    destination = CERT_PATHS[path];
  }
  return destination ? `${PRODUCT_ORIGIN}${destination}${url.search}` : null;
}

/** Normalize old saved menu destinations too, without overwriting admin customization. */
export function officialProductLink(value: string): string {
  try {
    const url = new URL(value);
    if (/^(www\.)?(star|certificacao)\.fisioemortopedia\.com\.br$/.test(url.hostname)) {
      return productRedirect(value) || value;
    }
    if (/^(www\.)?e-fisio\.wiki\.br$/.test(url.hostname) && url.pathname === "/") {
      return `${PRODUCT_ORIGIN}/e-fisio${url.search}${url.hash}`;
    }
    if (url.hostname === "materiais.fisioemortopedia.com.br" && ["/agente-vd", "/agente-flashfeo"].includes(url.pathname.replace(/\/+$/, ""))) {
      return `${PRODUCT_ORIGIN}/agente-raciocinio${url.search}${url.hash}`;
    }
  } catch { /* relative internal link */ }
  if (["/revista-star", "/imersao-pbe-star", "/certificacao-star"].some((path) => value.split(/[?#]/)[0] === path)) {
    return value.replace(/^\/[^?#]+/, "/star");
  }
  return value;
}